import config from 'config';
import { put, takeLatest } from 'redux-saga/effects';
import NetworkHandler from 'utils/network';
import NotificationHandler from 'utils/notification';
import { actions as tripOfSetTicketActions } from '../slices/TripSetTicketSlice';

function* getTripSetTicketReport({ payload: { page, limit, filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('trip_statistics_for_no_revenue')}/${filters.route_id}/set`, {
            params: {
                ...filters,
                page: page ? page - 1 : null,
                size: limit,
            },
        });
        yield put({ type: tripOfSetTicketActions.get_list_succeed.type, payload: { ...response.data } });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripOfSetTicketActions.get_list_failed.type, payload: error });
    }
}

function* exportTripSetTicketReport({ payload: { filters } }) {
    try {
        const response = yield NetworkHandler.get(`${config.getUrl('trip_statistics_for_no_revenue')}/${filters.route_id}/set`, {
            params: {
                ...filters,
                export: true,
            },
        });
        NotificationHandler.notifyDownloadBox(response.data);
        yield put({ type: tripOfSetTicketActions.export_list_succeed.type });
    } catch (error) {
        NotificationHandler.notifyError(error.message);
        yield put({ type: tripOfSetTicketActions.export_list_failed.type, payload: error });
    }
}


function* watchRequestDetail() {
    yield takeLatest(tripOfSetTicketActions.get_list, getTripSetTicketReport);
    yield takeLatest(tripOfSetTicketActions.export_list, exportTripSetTicketReport);
}

export default watchRequestDetail;
